import { clsx } from '../../lib/clsx.ts';

import { type Theme } from '../../theme/theme';
import styles from './Icon.module.css';

type ThemeIconSize = Theme['icon'][Extract<keyof Theme['icon'], `size_${string}`>];

interface IconProps {
  className?: string;
  source: string;
  size?: ThemeIconSize;
}

/**
 * Renders pre-colored icons (e.g. Homey logos, app brand icons) using
 * background-image. Unlike Glyph, Icon preserves the original icon colors
 * and does not accept a color prop.
 */
export function Icon(props: IconProps) {
  return (
    <span
      className={clsx(styles.root, props.className)}
      style={{
        '--prop-background-image': `url("${props.source}")`,
        '--prop-size': props.size,
      }}
    />
  );
}
